
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CashflowModels from './CashflowModels';
import BalanceSheetImpact from './BalanceSheetImpact';
import GapAnalysis from './GapAnalysis';

const ALMForecasting = () => {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Forecasting & Scenario Analysis</CardTitle>
          <CardDescription>
            Perform advanced ALM forecasting with sophisticated models and simulations
          </CardDescription>
        </CardHeader>
        <CardContent className="p-0">
          <Tabs defaultValue="cashflow" className="w-full">
            <div className="border-b px-6">
              <TabsList className="h-12">
                <TabsTrigger value="cashflow">Cashflow Models</TabsTrigger>
                <TabsTrigger value="balance-sheet">Balance Sheet Impact</TabsTrigger>
                <TabsTrigger value="gap-analysis">Gap Analysis & Simulations</TabsTrigger>
              </TabsList>
            </div>
            <div className="p-6">
              <TabsContent value="cashflow" className="mt-0">
                <CashflowModels />
              </TabsContent>
              <TabsContent value="balance-sheet" className="mt-0">
                <BalanceSheetImpact />
              </TabsContent>
              <TabsContent value="gap-analysis" className="mt-0">
                <GapAnalysis />
              </TabsContent>
            </div>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default ALMForecasting;
